import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BarcodeGenerator from '../components/BarcodeGenerator';
import api from '../utils/api';
import './PrintableOrder.css';

function PrintableOrder() {
    const { id } = useParams();
    const { token } = useAuth();
    const [order, setOrder] = useState(null);
    const [shipment, setShipment] = useState(null);
    const [barcodeData, setBarcodeData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Barkod değerini belirleyen fonksiyon (Sadece Kargonomi API'den gelen barkod)
    const getBarcodeValue = () => {
        if (!shipment) return null;
        
        console.log('[PrintableOrder] Barkod değeri belirleniyor...');
        console.log('[PrintableOrder] Shipment verisi:', shipment);
        
        // Sadece Kargonomi API'den gelen barkod verisini kullan
        if (barcodeData && barcodeData.barcodeValue) {
            console.log('[PrintableOrder] Kargonomi barkod kullanılıyor:', barcodeData.barcodeValue);
            return {
                value: barcodeData.barcodeValue,
                type: barcodeData.barcodeType || 'kargonomi_barcode',
                label: 'Kargonomi Barkodu'
            };
        }
        
        console.warn('[PrintableOrder] Kargonomi barkod verisi bulunamadı');
        console.warn('[PrintableOrder] BarcodeData:', barcodeData);
        return null;
    };

    useEffect(() => {
        const fetchOrder = async () => {
            if (!token) return;
            try {
                // Sipariş bilgilerini al
                console.log('[PrintableOrder] Sipariş bilgileri alınıyor, ID:', id);
                const data = await api(`/api/orders/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                console.log('[PrintableOrder] Sipariş verisi alındı:', data);
                setOrder(data);

                // Kargo bilgilerini al
                try {
                    const shipmentResponse = await api(`/api/shipments/order/${id}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    const shipmentData = shipmentResponse.data || shipmentResponse;
                    console.log('[PrintableOrder] Shipment verisi alındı:', shipmentData);
                    setShipment(shipmentData);
                    
                    // Kargonomi API'den doğru barkod bilgisini al
                    if (shipmentData && (shipmentData.kargonomiShipmentId || shipmentData.kargonomi_shipment_id)) {
                        try {
                            console.log('[PrintableOrder] Kargonomi barkod API çağrısı yapılıyor...');
                            const barcodeResponse = await api(`/api/kargonomi/order-barcode/${id}`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                            });
                            console.log('[PrintableOrder] Kargonomi barkod API yanıtı:', barcodeResponse);
                            if (barcodeResponse.success) {
                                setBarcodeData(barcodeResponse.data);
                                console.log('[PrintableOrder] Kargonomi barkod verisi alındı:', barcodeResponse.data);
                            } else {
                                console.warn('[PrintableOrder] Kargonomi barkod API başarısız:', barcodeResponse);
                            }
                        } catch (barcodeErr) {
                            console.error('[PrintableOrder] Kargonomi barkod API hatası:', barcodeErr);
                            console.warn('[PrintableOrder] Kargonomi barkod alınamadı:', barcodeErr.message);
                        }
                    } else {
                        console.log('[PrintableOrder] Kargonomi shipment ID bulunamadı, barkod API çağrısı yapılmıyor');
                    }
                } catch (shipmentErr) {
                    console.error('[PrintableOrder] Shipment API hatası:', shipmentErr);
                    console.warn('Kargo bilgileri alınamadı:', shipmentErr.response?.data || shipmentErr.message);
                    setShipment(null);
                }
            } catch (err) {
                console.error(err);
                alert("Sipariş yüklenemedi.");
            } finally {
                setLoading(false);
            }
        };
        fetchOrder();
    }, [id, token]);
    
    useEffect(() => {
        if (!loading && order) {
            // Veri yüklendikten ve barkod (varsa) çizildikten sonra yazdırma ekranını aç
            setTimeout(() => window.print(), 500);
        }
    }, [loading, order]);

    if (loading) return <div className="p-10 text-center">Yükleniyor...</div>;
    if (!order) return <div className="p-10 text-center">Sipariş bulunamadı.</div>;

    const address = order.shipping_address || {};
    const barcodeInfo = getBarcodeValue();

    return (
        <div className="bg-gray-100 min-h-screen">
             <div className="p-4 sm:p-8 no-print">
                 <button onClick={() => window.print()} className="bg-brand-green text-white px-6 py-2 rounded-md shadow-md hover:bg-brand-green-light">
                     Yazdır
                 </button>
             </div>
             <div className="printable-area bg-white max-w-4xl mx-auto p-8 border shadow-lg">
                 <header className="flex justify-between items-start pb-6 border-b border-gray-200">
                     <div className="flex items-center">
                         <div className="bg-gradient-to-r from-brand-green to-emerald-600 p-3 rounded-lg shadow-sm">
                             <img src="/minela_kids_logo.jpg" alt="Minela Kids Logo" className="h-16 w-auto" />
                         </div>
                         <div className="ml-4">
                             <h2 className="text-xl font-bold text-gray-800">Minela Kids</h2>
                             <p className="text-sm text-gray-600">Çocuk Giyim & Oyuncak</p>
                             <p className="text-xs text-gray-500">Türkiye</p>
                         </div>
                     </div>
                     <div className="text-right">
                         <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-lg shadow-sm">
                             <h1 className="text-2xl font-bold">SİPARİŞ FORMU</h1>
                             <p className="text-sm opacity-90">Sipariş No: <strong>MINELA-{order.order_number}</strong></p>
                             <p className="text-sm opacity-90">Tarih: {new Date(order.created_at).toLocaleDateString('tr-TR')}</p>
                         </div>
                     </div>
                 </header>

                 {/* Teslimat Adresi - Premium Tasarım */}
                 <section className="my-8">
                     <h2 className="text-lg font-bold mb-4 text-brand-green flex items-center">
                         <span className="w-6 h-6 bg-brand-green rounded-full flex items-center justify-center mr-2 text-white text-sm">📍</span>
                         Teslimat Adresi
                     </h2>
                     <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200 shadow-sm">
                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                             <div>
                                 <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                                     <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                     Müşteri Bilgileri
                                 </h3>
                                 <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                     <p className="font-semibold text-lg text-gray-800 mb-1">{address.full_name || address.name || 'Belirtilmemiş'}</p>
                                     <p className="text-sm text-gray-600">📞 {address.phone || 'Belirtilmemiş'}</p>
                                     {address.email && <p className="text-sm text-gray-600">✉️ {address.email}</p>}
                                 </div>
                             </div>
                             <div>
                                 <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                                     <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                                     Adres Bilgileri
                                 </h3>
                                 <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                                     <p className="text-sm text-gray-700 mb-1">{address.address_line || address.address || ''}</p>
                                     <p className="text-sm text-gray-700">{address.neighborhood || ''} {address.district || ''}</p>
                                     <p className="text-sm text-gray-700 font-medium">{address.city || ''}</p>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </section>

                 {/* Kargo Bilgileri */}
                 {(order.kargonomi_shipment_id || order.tracking_number || order.shipping_company) ? (
                     <section className="my-6">
                         <h2 className="text-lg font-bold mb-2 text-brand-green">🚚 Kargo Bilgileri</h2>
                         <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200 shadow-sm">
                             <div className="space-y-6">
                                 {/* Kargo ve Takip Bilgileri - Birleştirilmiş */}
                                 <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm mb-4">
                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                         <div>
                                             <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                                                 <span className="w-2 h-2 bg-brand-green rounded-full mr-2"></span>
                                                 Kargo Firması
                                             </h3>
                                             {barcodeData && barcodeData.shippingProvider ? (
                                                 <span className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-2 py-1 rounded text-sm font-medium">
                                                     {barcodeData.shippingProvider}
                                                 </span>
                                             ) : order.shipping_company ? (
                                                 <span className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-2 py-1 rounded text-sm font-medium">
                                                     {order.shipping_company}
                                                 </span>
                                             ) : (
                                                 <span className="text-gray-500 text-sm">Belirtilmemiş</span>
                                             )}
                                         </div>
                                         <div>
                                             <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
                                                 <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                                                 Takip Bilgileri
                                             </h3>
                                             <div className="space-y-1">
                                                 {order.tracking_number && (
                                                     <div className="flex items-center justify-between">
                                                         <span className="text-sm text-gray-600">Takip No:</span>
                                                         <span className="font-mono bg-gray-100 px-2 py-1 rounded text-xs border">
                                                             {order.tracking_number}
                                                         </span>
                                                     </div>
                                                 )}
                                                 {order.kargonomi_shipment_id && (
                                                     <div className="flex items-center justify-between">
                                                         <span className="text-sm text-gray-600">Kargonomi Ref:</span>
                                                         <span className="font-mono bg-yellow-100 px-2 py-1 rounded text-xs border text-yellow-800">
                                                             {order.kargonomi_shipment_id}
                                                         </span>
                                                     </div>
                                                 )}
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                                 
                                 {/* Barkod Bölümü - Premium Tasarım */}
                                 <div>
                                     {(() => {
                                         if (barcodeInfo) {
                                             return (
                                                 <div className="barcode-container w-full">
                                                     <div className="bg-white p-3 rounded-xl border border-gray-200 shadow-sm">
                                                         <div className="text-center mb-2">
                                                             <h3 className="font-bold text-sm text-gray-800">
                                                                 📊 {barcodeInfo.label}
                                                             </h3>
                                                         </div>
                                                         <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-3 rounded-lg border-2 border-gray-300 text-center">
                                                             <div className="w-full flex justify-center">
                                                                 <BarcodeGenerator 
                                                                     referenceNumber={barcodeInfo.value}
                                                                     width={8}
                                                                     height={80}
                                                                     fontSize={14}
                                                                     displayValue={true}
                                                                     format="CODE128"
                                                                 />
                                                             </div>
                                                         </div>
                                                     </div>
                                                 </div>
                                             );
                                         }
                                         
                                         return (
                                             <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                                                 <div className="text-center">
                                                     <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                                         <span className="text-2xl text-gray-400">📦</span>
                                                     </div>
                                                     <h3 className="font-semibold text-gray-800 mb-2">
                                                         Barkod Bilgisi Bulunamadı
                                                     </h3>
                                                     <p className="text-sm text-gray-600 mb-4">
                                                         Bu sipariş için henüz Kargonomi barkod bilgisi mevcut değil.
                                                     </p>
                                                     {barcodeData && barcodeData.debug && (
                                                         <div className="bg-gray-50 p-4 rounded-lg text-left">
                                                             <p className="text-xs font-semibold text-gray-700 mb-2">Debug Bilgileri:</p>
                                                             <div className="text-xs text-gray-600 space-y-1">
                                                                 <p>Kargonomi ID: {barcodeData.debug.kargonomiShipmentId || 'Yok'}</p>
                                                                 <p>Webservice Order ID: {barcodeData.debug.shippingWebserviceOrderId || 'Yok'}</p>
                                                                 <p>Reference: {barcodeData.debug.referenceNumber || 'Yok'}</p>
                                                                 <p>Tracking: {barcodeData.debug.trackingCode || 'Yok'}</p>
                                                             </div>
                                                         </div>
                                                     )}
                                                 </div>
                                             </div>
                                         );
                                     })()}
                                 </div>
                             </div>
                         </div>
                     </section>
                 ) : (
                     <section className="my-6">
                         <h2 className="text-lg font-bold mb-2 text-gray-500">🚚 Kargo Bilgileri</h2>
                         <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
                             <div className="text-center">
                                 <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                                     <span className="text-xl text-gray-400">📦</span>
                                 </div>
                                 <p className="text-gray-600 text-sm">Bu sipariş için henüz kargo bilgisi bulunmuyor.</p>
                             </div>
                         </div>
                     </section>
                 )}

                 <section className="my-8">
                     <h2 className="text-lg font-bold mb-4 text-brand-green flex items-center">
                         <span className="w-6 h-6 bg-brand-green rounded-full flex items-center justify-center mr-2 text-white text-sm">📦</span>
                         Sipariş İçeriği
                     </h2>
                     <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-6 rounded-xl border border-purple-200 shadow-sm">
                         <div className="bg-white rounded-lg overflow-hidden shadow-sm">
                             <table className="w-full">
                                 <thead>
                                     <tr className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                                         <th className="p-4 text-left font-semibold">Ürün Adı</th>
                                         <th className="p-4 text-left font-semibold">Seçenek</th>
                                         <th className="p-4 text-center font-semibold">Adet</th>
                                         <th className="p-4 text-right font-semibold">Birim Fiyat</th>
                                         <th className="p-4 text-right font-semibold">Toplam Fiyat</th>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     {order.order_items && order.order_items.map((item, index) => (
                                         <tr key={item.id} className={`border-b border-gray-100 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
                                             <td className="p-4">
                                                 <div>
                                                     <p className="font-medium text-gray-800">{item.product_name_at_purchase}</p>
                                                 </div>
                                             </td>
                                             <td className="p-4">
                                                 <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                                     {item.variant_details_at_purchase.color} - {item.variant_details_at_purchase.size}
                                                 </span>
                                             </td>
                                             <td className="p-4 text-center">
                                                 <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                                                     {item.quantity}
                                                 </span>
                                             </td>
                                             <td className="p-4 text-right">
                                                 <span className="text-gray-700 font-medium">₺{item.price_at_purchase.toFixed(2)}</span>
                                             </td>
                                             <td className="p-4 text-right">
                                                 <span className="text-gray-900 font-bold">₺{(item.price_at_purchase * item.quantity).toFixed(2)}</span>
                                             </td>
                                         </tr>
                                     ))}
                                 </tbody>
                                 <tfoot>
                                     <tr className="bg-gradient-to-r from-green-600 to-emerald-600 text-white">
                                         <td colSpan="4" className="p-4 text-right font-bold text-lg">GENEL TOPLAM</td>
                                         <td className="p-4 text-right font-bold text-xl">₺{order.total_price.toFixed(2)}</td>
                                     </tr>
                                 </tfoot>
                             </table>
                         </div>
                     </div>
                 </section>
                 <footer className="mt-8 pt-6 border-t border-gray-200 text-center">
                     <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-4 rounded-lg">
                         <p className="text-sm text-gray-600 font-medium">Minela Kids - www.minelakids.com</p>
                         <p className="text-xs text-gray-500 mt-1">Bizi tercih ettiğiniz için teşekkür ederiz! ❤️</p>
                     </div>
                 </footer>
             </div>
         </div>
    );
}

export default PrintableOrder;